import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Notifications } from '../../interfaces/toolbar/notifiactions.interface';

@Component({
  selector: 'mg-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnChanges {
  @Input() notifications: Notifications[] = [];
  @Output() closePopover: EventEmitter<any> = new EventEmitter();
  @Output() returnNotifations: EventEmitter<Notifications[]> = new EventEmitter();

  constructor() { }
  newNotifications : number = 0;
  some_text = '';
  inside = false;
  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.newNotifications = this.notifications.length;
    this.returnNotifations.emit(this.notifications);
  }

  @HostListener("click")
  clicked() {
    this.inside = true;
  }


  @HostListener("document:click")
  clickedOut() {
    this.some_text = this.inside ? "Event Triggered" : "Event Triggered Outside Component";
    if(!this.inside){
      this.closePopover.emit(this.inside);
    }
    this.inside = false;
  }

  openNotification(url: string){
    window.open(url);
  }

  closeNotification(id: string){
    const positionId = this.notifications.findIndex(notificationId => notificationId.id === id);
    this.notifications.splice(positionId,1);
    this.newNotifications = this.notifications.length;
    this.returnNotifations.emit(this.notifications);
  }


}
